export const state = () => ({
  // Значение, которое было при клике на ячейку
  // (чтобы не отправлять запрос,если значение не изменилось)
  focusedValue: null,
});

export const mutations = {
  setFocusedValue(state, value) {
    state.focusedValue = value;
  },
};

export const actions = {
  setFocusedValue({ commit }, value) {
    commit('setFocusedValue', value);
  },
};

export default { namespaced: true, state, mutations, actions };
